import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { 
  SquaresFour, 
  ArrowsLeftRight, 
  Drop, 
  ChartLine,
  BookOpen
} from '@phosphor-icons/react';

const navigation = [
  { name: 'Dashboard',  path: '/',               icon: SquaresFour },
  { name: 'Channels',   path: '/channels',        icon: ChartLine },
  { name: 'Payments',   path: '/payments',        icon: ArrowsLeftRight },
  { name: 'Netting',    path: '/netting',         icon: Drop },
  { name: 'Log',        path: '/deficit-history', icon: BookOpen },
];

export const Layout = ({ children, nettingEnabled = true }) => {
  const location = useLocation();

  return (
    <div className="flex flex-col h-screen bg-gray-50 overflow-hidden">
      {/* Main Content — full width, padded bottom for nav bar */}
      <main className="flex-1 min-w-0 overflow-y-auto overflow-x-hidden pb-20">
        <div className="p-4 max-w-[1600px] mx-auto">
          {children}
        </div>
      </main>

      {/* Bottom Navigation Bar — 5 items, larger icons */}
      <nav
        className="fixed bottom-0 left-0 right-0 h-16 bg-white border-t border-gray-200 flex items-stretch z-50"
        data-testid="bottom-nav"
      >
        {navigation.map((item) => {
          const Icon = item.icon;
          const isActive = location.pathname === item.path;
          const isDisabled = item.path === '/netting' && !nettingEnabled;

          if (isDisabled) {
            return (
              <div
                key={item.path}
                title="Netting disabled — select Multilateral Netting algorithm"
                data-testid={`nav-${item.name.toLowerCase().replace(' ', '-')}-disabled`}
                className="flex flex-col items-center justify-center flex-1 gap-1 text-xs font-semibold text-gray-300 cursor-not-allowed select-none"
              >
                <Icon size={26} weight="regular" />
                <span>{item.name}</span>
              </div>
            );
          }

          return (
            <NavLink
              key={item.path}
              to={item.path}
              title={item.name}
              data-testid={`nav-${item.name.toLowerCase().replace(' ', '-')}`}
              className={`flex flex-col items-center justify-center flex-1 gap-1 text-xs font-semibold transition-all ${
                isActive
                  ? 'text-indigo-600 bg-indigo-50'
                  : 'text-gray-400 hover:text-gray-700 hover:bg-gray-50'
              }`}
            >
              <Icon size={26} weight={isActive ? 'fill' : 'regular'} />
              <span>{item.name}</span>
            </NavLink>
          );
        })}
      </nav>
    </div>
  );
};
